export const INDEX_ROUTE = "/"
export const CATALOG_ROUTE = "/catalog"
export const CATEGORY_PLANED_BOARD = "/planed-board"
export const CATEGORY_PLANED_BLOCK = "/planed-block"
export const CATEGORY_EDGED_BOARD = "/edged-board"
export const CATEGORY_BLOCK_HOUSE = "/block-house"
export const CATEGORY_IMITATION_TIMBER = "/imitation-timber"
export const CATEGORY_SHTIL = "/shtil"
export const CATEGORY_FLOOR_BOARD = "/floor-board"
export const CATEGORY_EVRO_VAGONKA = "/evro-vagonka"
export const CONTACT = '/contact'
export const PICTURES_PATH = 'https://holz-city.ru:444/static/img/'
export const ABOUT_ROUTE = '/about'
export const PHOTO_ROUTE = '/photo'
export const PRIVACY_POLICY = '/privacy-policy'